import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal", "confirmDiscard"];
  static values = { changed: Boolean};

  connect() {
    if(this.hasModalTarget){
      this.modalTarget.close();
    }
    this.changedValue = false;
    
    // Listen for form changes from other controllers (like canvas)
    this.boundFormChangedHandler = this.handleFormChanged.bind(this);
    document.addEventListener('formChanged', this.boundFormChangedHandler);
    
    // Listen for form reset events
    this.boundFormResetHandler = this.handleFormReset.bind(this);
    document.addEventListener('formReset', this.boundFormResetHandler);
  }

  disconnect() {
    // Clean up event listeners
    if (this.boundFormChangedHandler) {
      document.removeEventListener('formChanged', this.boundFormChangedHandler);
    }
    if (this.boundFormResetHandler) {
      document.removeEventListener('formReset', this.boundFormResetHandler);
    }
  }

  confirmLeave(event) {
    const options = JSON.parse(event.target.dataset.confirmOptions || "{}");
    if (this.hasConfirmDiscardTarget) {
      this.confirmDiscardTarget.dataset.url = event.currentTarget.dataset.url
    }
    if (this.changedValue || options.forceChange) {
      event.preventDefault();
      if (event.params.id) {
        this.element.querySelector(`#${event.params.id}`).showModal();
      } else {
        this.modalTarget.showModal();
      }
    }
  }

  cancel(event) {
    if (event.params.id) {
      this.element.querySelector(`#${event.params.id}`).close();
    } else {
      this.modalTarget.close();
    }
    event.preventDefault();
  }

  showModal(event) {
    if (this.hasConfirmDiscardTarget) {
      this.confirmDiscardTarget.href = event.currentTarget.dataset.url
    }
    event.preventDefault();
    if (event.params.id) {
      this.element.querySelector(`#${event.params.id}`).showModal();
    } else {
      this.modalTarget.showModal();
    }
  }

  closeModal(event) {
    if (event.params.id) {
      this.element.querySelector(`#${event.params.id}`).close();
    } else {
      this.modalTarget.close();
    }
  }

  onInputChange(_) {
    if (!this.changedValue) {
      this.changedValue = true;
    }
  }

  handleFormChanged(event) {
    // Handle form changes from other controllers (like canvas)
    if (!this.changedValue) {
      this.changedValue = true;
    }
  }

  handleFormReset(event) {
    // Reset the change detection when form is successfully submitted
    this.changedValue = false;
  }

  confirmDiscard() {
    const url = this.confirmDiscardTarget.dataset.url

    if (url) {
      window.location.href = url
    }
  }

  // Handle delete operations for Plan page
  handlePlanDelete(event) {
    event.preventDefault()
    // Get URL from confirm button's data-url attribute
    const url = event.target.dataset.url
    
    if (url) {
      // Create a hidden form to submit DELETE request
      const form = document.createElement('form')
      form.method = 'POST'
      form.action = url
      
      // Add CSRF token
      const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      const csrfInput = document.createElement('input')
      csrfInput.type = 'hidden'
      csrfInput.name = 'authenticity_token'
      csrfInput.value = csrfToken
      form.appendChild(csrfInput)
      
      // Add method override to simulate DELETE request
      const methodInput = document.createElement('input')
      methodInput.type = 'hidden'
      methodInput.name = '_method'
      methodInput.value = 'DELETE'
      form.appendChild(methodInput)
      
      // Add form to page and submit
      document.body.appendChild(form)
      form.submit()
    } else {
      console.error('No URL found for delete operation')
      this.showNotification('Delete failed: No URL found', 'error')
    }
  }

  // Show notification
  showNotification(message, type = 'info') {
    // Create notification element using existing toast styles
    const notification = document.createElement('div')
    notification.className = `toast__content ${type === 'error' ? 'toast__content--error' : ''}`
    
    const messageSpan = document.createElement('span')
    messageSpan.className = 'toast__message'
    messageSpan.textContent = message
    
    notification.appendChild(messageSpan)
    
    // Create container (if it doesn't exist)
    let container = document.querySelector('.toast__container')
    if (!container) {
      container = document.createElement('div')
      container.className = 'toast__container'
      document.body.appendChild(container)
    }
    
    // Add to container
    container.appendChild(notification)
    
    // Trigger animation
    notification.style.animation = 'flashMessage 3s linear'
    
    // Remove after animation ends
    setTimeout(() => {
      if (notification.parentNode) {
        notification.parentNode.removeChild(notification)
      }
    }, 3000)
  }

  // Reload Plan page data
  reloadPlanData() {
    // Trigger page reload or refetch data
    // Here you can implement specific reload logic as needed
    window.location.reload()
  }
}
